<div class="main">
  <h2>Estimulaciones de Fractura en ICP</h2>

  <div style="min-height: 50vh; width: 100vw" *ngIf="isLoading">
    <div class="loading-shade">
      <mat-spinner></mat-spinner>
    </div>
  </div>

  <div class="container" *ngIf="!isLoading">
    <table
      mat-table
      [dataSource]="fractureStimulations"
      class="fracture-stimulations"
    >
      <ng-container matColumnDef="startDate">
        <mat-header-cell *matHeaderCellDef> Fecha Int </mat-header-cell>
        <mat-cell *matCellDef="let fs">
          {{ fs.startDate | date : "dd/MM/yyyy" }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="top">
        <mat-header-cell *matHeaderCellDef> Tope [m] </mat-header-cell>
        <mat-cell *matCellDef="let fs">
          {{ fs.top | number : "1.1-1" }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="base">
        <mat-header-cell *matHeaderCellDef> Base [m] </mat-header-cell>
        <mat-cell *matCellDef="let fs">
          {{ fs.base | number : "1.1-1" }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="fluidType">
        <mat-header-cell *matHeaderCellDef> Tipo Fluido </mat-header-cell>
        <mat-cell *matCellDef="let fs">
          {{ fs.fluidType }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="totalFluid">
        <mat-header-cell *matHeaderCellDef> Total Fluido </mat-header-cell>
        <mat-cell *matCellDef="let fs">
          {{ fs.totalFluid | number : "1.2-2" }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="sandType">
        <mat-header-cell *matHeaderCellDef> Tipo Arena </mat-header-cell>
        <mat-cell *matCellDef="let fs">
          {{ fs.sandType }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="totalSand">
        <mat-header-cell *matHeaderCellDef> Total Arena </mat-header-cell>
        <mat-cell *matCellDef="let fs">
          {{ fs.totalSand | number : "1.0-0" }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="minimalSurfacePressure">
        <mat-header-cell *matHeaderCellDef>
          Presión Min <br />
          Sup. [psi]
        </mat-header-cell>
        <mat-cell *matCellDef="let fs">
          {{ fs.minimalSurfacePressure | number : "1.2-2" }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="maximalSurfacePressure">
        <mat-header-cell *matHeaderCellDef>
          Presion Max <br />
          Sup. [psi]
        </mat-header-cell>
        <mat-cell *matCellDef="let fs">
          {{ fs.maximalSurfacePressure | number : "1.2-2" }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="rupturePressure">
        <mat-header-cell *matHeaderCellDef>
          Presion <br />
          Ruptura [psi]
        </mat-header-cell>
        <mat-cell *matCellDef="let fs">
          {{ fs.rupturePressure | number : "1.2-2" }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="instantPressure">
        <mat-header-cell *matHeaderCellDef>
          Presion <br />
          Instan [psi]
        </mat-header-cell>
        <mat-cell *matCellDef="let fs">
          {{ fs.instantPressure | number : "1.2-2" }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="finalSurfacePressure">
        <mat-header-cell *matHeaderCellDef>
          Presion Final <br />
          Sup. [psi]
        </mat-header-cell>
        <mat-cell *matCellDef="let fs">
          {{ fs.finalSurfacePressure | number : "1.2-2" }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="sandSize">
        <mat-header-cell *matHeaderCellDef>
          Tamaño <br />
          Arena [sk]
        </mat-header-cell>
        <mat-cell *matCellDef="let fs">
          {{ fs.sandSize }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="noData">
        <mat-footer-cell *matFooterCellDef colspan="4">
          <div class="footer">
            <div class="footer-no-data">No se encontraron datos.</div>
            <div class="footer-no-data-origin">
              De existir datos en el sistema de origen, podrás visualizarlos
              acá.
            </div>
          </div>
        </mat-footer-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      <mat-footer-row
        *matFooterRowDef="['noData']"
        [ngClass]="{ 'hide-footer': hideFooter }"
      ></mat-footer-row>
    </table>
  </div>
</div>
